import React, { useState, useRef } from 'react'
import Slidertwo from '../Menhometwo/Slidertwo'
import Loan from '../Menhometwo/Loan'
import Headertwo from '../Menhometwo/Headertwo'
import Company from '../Menhometwo/Company'
import Get from '../Menhome/Get';
import We from '../Menhometwo/We';
import Testtwo from '../Menhometwo/Testtwo';
import Building from '../Menhometwo/Building';
import Trusted from '../Menhometwo/Trusted';
import Ourtwo from '../Menhometwo/Ourtwo';
import Brandtwo from '../Menhometwo/Brandtwo';
import Maptwo from '../Menhometwo/Maptwo';

const Home02 = () => {
  
    return (
        <>
            {/* <Headertwo/> */}
            <Slidertwo />
            <Loan />
            <Company/>
            <Get/>
            <We/>
            <Testtwo/>
            <Building/>
            <Trusted/>
            {/* <Ourtwo/> */}
            {/* <Brandtwo/> */}
            <Maptwo/>
        </>

    )
}

export default Home02